<template>
  <div :class="{'container-fluid':true, 'h-100':true, allowScroll: !this.selectedProperty}">
    <div class="form-row mb-2">
      <div class="col-12 mb-2">
        <div class="card">
          <div class="card-header py-2 px-2 d-flex justify-content-between align-items-center">
            <template v-if="selectedProperty">
              <h5 class="d-flex justify-content-between align-items-center font-weight-bold mb-0">
                Reviewing {{ indexCount }}
                <small class="m-0 ml-2 text-muted font-weight-normal">
                  {{ selectedProperty.Id }} |
                  {{ selectedProperty.Login }}
                  <div class="d-inline">
                    <button
                      v-if="selectedProperty !== null"
                      class="btn btn-link btn-sm font-weight-bold dropdown-toggle mr-1 ml-1 text-capitalize"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      View Properties In
                    </button>
                    <div class="dropdown-menu preview-dropdown">
                      <template v-for="language in languages">
                        <a
                          class="dropdown-item px-2"
                          target="_blank"
                          :href="searchPreviewURL[language.code]"
                          :key="searchPreviewURL[language.code]"
                        >
                          {{ language.name }}
                        </a>
                      </template>
                    </div>
                  </div> |
                  {{ statusTypes[ selectedProperty.status.status ].label }}
                </small>
              </h5>
            </template>
            <div class="d-flex align-items-center">
              <p class="m-0 text-muted">
                <button
                  type="button"
                  class="btn btn-link btn-sm p-0 font-weight-bold mr-2"
                  @click="search.open = !search.open"
                >
                  Property Search
                </button>
              </p>
              <select
                v-if="selectedProperty !== null"
                class="form-control d-inline-block w-auto form-control-sm mr-1 font-weight-bold"
                :disabled="loading || disabled"
                v-model="saveStatus"
              >
                <option
                  v-for="status in statusTypes"
                  :disabled="status.value === 'pending'"
                  :value="status.value"
                  :key="status.value"
                >
                  {{ status.label }}
                </option>
              </select>
              <button
                v-if="selectedProperty !== null"
                type="button"
                class="btn btn-info btn-sm font-weight-bold mr-1"
                @click="handleSkip(true)"
                :disabled="loading"
                title="Selects the next property without saving the currently selected one (ALT+d)"
              >
                Skip Property
              </button>
              <button
                v-if="selectedProperty !== null"
                type="button"
                class="btn btn-primary btn-sm font-weight-bold mr-1"
                @click="handleSave(true)"
                :disabled="loading || disabled"
                title="Save the current property and selects another (ALT+s)"
              >
                Save &amp; Continue
              </button>
              <button
                v-if="selectedProperty !== null"
                type="button"
                class="btn btn-danger btn-sm font-weight-bold"
                @click="handleSkip(false)"
                :disabled="loading || disabled"
                title="Discards any changes and stops reviewing"
              >
                Cancel Reviewing
              </button>
            </div>
          </div>
          <template v-if="search.open || !selectedProperty">
            <div class="card-body py-2 px-2">
              <form @submit.prevent="handleSearch">
                <div class="form-row">
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Import Date<sup>1</sup></label>
                    <input
                      type="date"
                      required
                      class="form-control"
                      v-model="search.date"
                      :disabled="loading"
                    >
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">QC Status</label>
                    <select
                      class="form-control"
                      placeholder="Status"
                      v-model="search.status"
                      :disabled="loading"
                    >
                      <template v-for="status in statusTypes">
                        <option
                          v-if="!status.hide"
                          :value="status.value"
                          :key="status.value"
                          :selected="status.default"
                        >
                          {{ status.label }}
                        </option>
                      </template>
                      <option
                        value="any"
                      >
                        Any
                      </option>
                    </select>
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Property Status</label>
                    <select
                      class="form-control"
                      :disabled="loading"
                      v-model="search.propertyStatus"
                    >
                      <option :value="PropertyStatusAll">
                        All
                      </option>
                      <option :value="PropertyStatusOnline">
                        Online
                      </option>
                      <option :value="PropertyStatusOffline">
                        Offline
                      </option>
                    </select>
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Offer Type</label>
                    <select
                      class="form-control"
                      :disabled="loading"
                      v-model="search.offerType"
                    >
                      <option
                        value="any"
                        :selected="search.offerType === 'any'"
                      >
                        All
                      </option>
                      <option
                        value="for-sale"
                        :selected="search.offerType === 'for-sale'"
                      >
                        For Sale
                      </option>
                      <option
                        value="for-rent"
                        :selected="search.offerType === 'for-rent'"
                      >
                        For Rent
                      </option>
                      <option
                        value="for-holidays"
                        :selected="search.offerType === 'for-holidays'"
                      >
                        For Holiday
                      </option>
                    </select>
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Property Order</label>
                    <select
                      class="form-control"
                      placeholder="Status"
                      v-model="search.order"
                      :disabled="loading"
                    >
                      <template v-for="status in orderTypes">
                        <option
                          :value="status.value"
                          :key="status.value"
                          :selected="status.default"
                        >
                          {{ status.label }}
                        </option>
                      </template>
                    </select>
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Property ID/Ref</label>
                    <input
                      class="form-control"
                      type="number"
                      placeholder="4686529"
                      v-model.trim.number="search.propertyID"
                    >
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">Login</label>
                    <input
                      class="form-control"
                      type="text"
                      placeholder="TSW37781"
                      v-model.trim="search.login"
                    >
                  </div>
                  <div class="form-group m-0 col-1">
                    <label class="text-truncate d-block small mb-0">Batch Size</label>
                    <select
                      class="form-control"
                      v-model.number="search.batchSize"
                    >
                      <option
                        :value="25"
                        :selected="search.batchSize === 25"
                      >
                        25
                      </option>
                      <option
                        :value="50"
                        :selected="search.batchSize === 50"
                      >
                        50 (default)
                      </option>
                      <option
                        :value="75"
                        :selected="search.batchSize === 75"
                      >
                        75
                      </option>
                      <option
                        :value="100"
                        :selected="search.batchSize === 100"
                      >
                        100
                      </option>
                      <option
                        :value="-1"
                        :selected="search.batchSize === -1"
                      >
                        Unlimited
                      </option>
                    </select>
                  </div>
                  <div class="form-group m-0 col">
                    <label class="text-truncate d-block small mb-0">&nbsp;</label>
                    <button
                      type="submit"
                      class="btn btn-primary w-100 font-weight-bold"
                      :disabled="search.loading || selectedProperty !== null"
                      :title="selectedProperty === null ? 'Search for properties to review' : 'Save the current property before searching.'"
                    >
                      Search Properties<i class="jam jam-search ml-1" />
                    </button>
                  </div>
                </div>
                <small class="text-muted"><sup>1</sup> Properties will be selected if they were imported on/after the chosen date.</small>
                <div
                  v-if="search.msg.length > 0"
                  class="alert alert-warning mt-2 mb-0"
                  v-html="search.msg"
                />
              </form>
              <template v-if="search.resultCount !== null">
                <hr>
                <template v-if="search.resultCount === 0">
                  <div class="alert alert-info mb-0">
                    <span class="font-weight-bold">No properties found matching that crtieria</span>
                  </div>
                </template>
                <template v-else>
                  <button
                    type="button"
                    class="btn btn-md btn-outline-primary w-100 mt-2 font-weight-bold"
                    @click="startReview"
                    :disabled="search.loading || selectedProperty !== null"
                    :title="selectedProperty === null ? '' : 'Save the current property before searching.'"
                  >
                    <template v-if="search.resultCount > search.batchSize">
                      Start Reviewing {{ search.batchSize > 0 ? search.batchSize : resultCountFormatted }} of {{ resultCountFormatted }} Properties
                    </template>
                    <template v-else>
                      Start Reviewing {{ new Intl.NumberFormat().format(search.resultCount) }} Properties
                    </template>
                  </button>
                </template>
              </template>
            </div>
          </template>
        </div>
      </div>
      <div
        v-if="!selectedProperty"
        class="col-12"
      >
        <rule-search />
      </div>
    </div>
    <div
      v-if="error.show"
      class="form-row"
    >
      <div
        class="col-12"
      >
        <div
          :class="`alert alert-${error.type} mb-2 px-2`"
        >
          <p
            v-if="error.title.length > 0"
            class="mb-2 font-weight-bold"
          >
            {{ error.title }}
          </p>
          <p class="m-0">
            {{ error.msg }}
          </p>
        </div>
      </div>
    </div>
    <template v-if="selectedProperty">
      <div
        id="pane-container"
        class="form-row h-100"
        v-hotkey="{
          'alt+s': handleSave,
          'alt+d':handleSkip
        }"
      >
        <div
          id="pane-left"
          class="col-12 col-xl-6"
        >
          <div class="pane-inner">
            <description-rule-handler
              v-model="rules.description"
              :property="selectedProperty"
              ref="descriptionHandler"
              :disabled="disabled"
            />
            <image-rule-handler
              v-model="rules.image"
              :property="selectedProperty"
              :rules="imageRules"
              ref="imageHandler"
              :disabled="disabled"
            />
          </div>
        </div>
        <div
          id="pane-right"
          class="col-12 col-xl-6"
        >
          <div class="pane-inner">
            <attribute-rule-handler
              v-model="rules.attribute"
              :property="selectedProperty"
              ref="attributeHandler"
              :disabled="disabled"
            />
            <feature-rule-handler
              v-model="rules.feature"
              :property="selectedProperty"
              ref="featureHandler"
              :disabled="disabled"
            />
            <media-file-rule-handler
              v-model="rules.media"
              :property="selectedProperty"
              ref="mediaFileHandler"
              :disabled="disabled"
            />
            <location-rule-handler
              v-model="rules.location"
              :property="selectedProperty"
              ref="locationHandler"
              :disabled="disabled"
            />
            <duplicate-property-handler
              :property-id="selectedProperty.Id"
              :disabled="disabled"
              ref="duplicatePropertyHandler"
            />
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="loading"
      id="form-loader"
    />
  </div>
</template>

<script>
import http from '../../http';
import store from '../../store';
import notify from '../../notifications';

import RuleSearch from './RuleSearch.vue';
import AttributeRuleHandler from './handlers/AttributeRuleHandler.vue';
import DescriptionRuleHandler from './handlers/DescriptionRuleHandler.vue';
import FeatureRuleHandler from './handlers/FeatureRuleHandler.vue';
import ImageRuleHandler from './handlers/ImageRuleHandler.vue';
import LocationRuleHandler from './handlers/LocationRuleHandler.vue';
import MediaFileRuleHandler from './handlers/MediaFileRuleHandler.vue';
import DuplicatePropertyHandler from './handlers/DuplicatePropertyHandler.vue';

import {
    RuleTypeAttribute,
    RuleTypeDescription,
    RuleTypeImage,
    RuleTypeFeature,
    RuleTypeLocation,
    RuleTypeMedia,
    RuleScopeProperty,
    RuleScopeLogin,
    StatusInReview,
    StatusReviewed,
    StatusPending,
    StatusDoNotReview,
    StatusReReview,
    PropertyStatusOnline,
    PropertyStatusOffline,
    PropertyStatusAll
} from './consts';

import {
    reviewStatuses,
    orderByOptions,
    availableLanguages
} from './common';

export default {
    data: () => ( {
        loading: false,
        disabled: false,
        search: {
            open: true,
            date: moment().format( 'YYYY-MM-DD' ),
            status: StatusPending,
            propertyStatus: PropertyStatusOnline,
            offerType: 'any',
            order: 'DESC',
            resultCount: null,
            propertyID: null,
            batchSize: 50,
            login: null,
            msg: ''
        },
        error: {
            show: false,
            title: '',
            msg: '',
            type: 'warning'
        },
        statusTypes: reviewStatuses,
        orderTypes: orderByOptions,
        selectedProperty: null,
        saveStatus: StatusReviewed,
        rules: {
            description: [],
            attribute: [],
            image: [],
            feature: [],
            media: [],
            location: []
        },
        propertyPreviewURL: {},
        searchPreviewURL: {},
        index: 0,
        skipped: []
    } ),
    computed: {
        descriptionRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeDescription );
        },
        attributeRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeAttribute );
        },
        imageRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeImage );
        },
        featureRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeFeature );
        },
        locationRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeLocation );
        },
        mediaRules() {
            if ( !this.selectedProperty ) {
                return [];
            }
            return this.selectedProperty.rules.filter( rule => rule.type === RuleTypeMedia );
        },
        searchParams() {
            const params = new URLSearchParams();

            if ( parseInt( this.search.propertyID ) ) {
                params.set( 'propertyID', this.search.propertyID );
                return params;
            }

            params.set( 'date', this.search.date );
            params.set( 'order', this.search.order );
            params.set( 'status', this.search.status );
            params.set( 'propertyStatus', this.search.propertyStatus );

            if ( this.search.login ) {
                params.set( 'login', this.search.login );
            }

            if ( this.skipped.length > 0 ) {
                params.set( 'skipped', this.skipped.join( ',' ) );
            }

            if ( this.search.offerType !== 'any' ) {
                params.set( 'offer', this.search.offerType );
            }

            return params;
        },
        resultCountFormatted() {
            return new Intl.NumberFormat().format( this.search.resultCount );
        },
        indexCount() {
            let count = '';
            if ( this.search.batchSize === -1 ) {
                count = this.resultCountFormatted;
            } else if ( this.search.resultCount > this.search.batchSize ) {
                count = this.search.batchSize;
            } else {
                count = this.resultCountFormatted;
            }
            return `(${this.index}/${count})`;
        }
    },
    methods: {
        clear() {
            this.selectedProperty = null;
            this.search.resultCount = null;
            this.error.show = false;
            this.index = 0;
            this.skipped = [];
            document.body.classList.remove( 'split-view' );
        },
        async handleSkip( selectNext = true ) {
            this.$store.dispatch( 'appLoading', true );

            const propertyID = parseInt( this.selectedProperty.Id );

            if ( !this.skipped.includes( propertyID ) ) {
                this.skipped.push( propertyID );
            }

            let status = '';

            if ( this.selectedProperty.status.status === StatusInReview ) {
                status = StatusPending;
            } else {
                status = this.selectedProperty.status.status;
            }

            const payload = {
                status: status
            };

            const response = await http.post( `property-qc/property/${propertyID}/status`, payload );

            if ( response.status !== 200 ) {
                this.error.title = `Failed setting statas for property ${propertyID}`;
                this.error.msg = 'Skipping was cancelled as setting the status for the property failed. Try again or contact an administrator.';
                this.error.type = 'danger';
                this.error.show = true;
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            if ( this.batchSize !== -1 && this.index === this.search.batchSize ) {
                const confirmContinue = confirm( `You've reviewed ${this.index}/${this.search.batchSize} properties. Do you want to continue reviewing?` );

                if ( !confirmContinue ) {
                    this.clear();
                    this.reset();
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }
            }

            const isSingleProperty = ( this.search.propertyID && this.search.propertyID > 0 );

            if ( selectNext && !isSingleProperty ) {
                await this.selectProperty();
            } else {
                this.clear();
            }

            this.reset();

            this.$store.dispatch( 'appLoading', false );
        },
        async handleSearch() {
            this.$store.dispatch( 'appLoading', true );
            this.search.msg = '';
            this.error.show = false;
            this.search.resultCount = null;

            const params = this.searchParams;

            const response = await http.get( `/property-qc/search?${params.toString()}` );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Search Failed',
                    text: 'The search failed, please try again'
                } );

                this.error.title = 'Search Failed';
                this.error.msg = 'The search failed, please try again';
                this.error.type = 'danger';
                this.error.show = true;

                this.$store.dispatch( 'appLoading', false );
                return;
            }

            const data = await response.json();

            this.search.resultCount = data.count;

            this.$store.dispatch( 'appLoading', false );
        },
        async handleSave( selectNext = true ) {
            this.$store.dispatch( 'appLoading', true );

            let state = null;

            for ( const handler in this.$refs ) {
                if ( !this.$refs[ handler ] ) {
                    continue;
                }

                state = this.$refs[ handler ].validate();
                if ( !state.valid ) {
                    break;
                }
            }

            if ( !state.valid ) {
                this.$store.dispatch( 'appLoading', false );
                alert( state.msg );
                return;
            }

            let rulesMerged = [];
            for ( let ruleSet in this.rules ) {
                rulesMerged = rulesMerged.concat( this.rules[ ruleSet ] );
            }

            const propertyRules = rulesMerged.filter( rule => 'scope' in rule && rule.scope === RuleScopeProperty );
            const loginRules = rulesMerged.filter( rule => 'scope' in rule && rule.scope === RuleScopeLogin );

            const propertyID = parseInt( this.selectedProperty.Id );

            const savePropertyRule = async () => {
                const payload = {
                    rules: propertyRules,
                    status: this.saveStatus,
                    login: this.selectedProperty.Login
                };

                const response = await http.post( `property-qc/property/${propertyID}`, payload );

                const data = await response.json();

                let error = null;

                if ( response.status !== 200 && !data.error && data.error.length === 0 ) {
                    error = {
                        title: '',
                        msg: 'Property Rules Failed to Save for unknown reason',
                        type: 'danger'
                    };
                }

                if ( response.status === 400 ) {
                    error = {
                        title: 'Rule validation/format issue detected',
                        msg: data.error,
                        type: 'danger'
                    };
                }

                if ( response.status === 500 ) {
                    error = {
                        title: 'Error detected while trying to save the rules. See the error message below or contact an administrator.',
                        msg: data.error,
                        type: 'danger'
                    };
                }

                return Promise.resolve( error );
            };

            const saveLoginRules = async () => {
                const login = this.selectedProperty.Login;

                const payload = {
                    rules: loginRules
                };

                const response = await http.post( `property-qc/login/${login}`, payload );

                const data = await response.json();

                let error = null;

                if ( response.status !== 200 && !data.error && data.error.length === 0 ) {
                    error = {
                        title: '',
                        msg: 'Login Rules Failed to Save for unknown reason',
                        type: 'danger'
                    };
                }

                if ( response.status === 400 ) {
                    error = {
                        title: 'Rule validation/format issue detected',
                        msg: data.error,
                        type: 'danger'
                    };
                }

                if ( response.status === 500 ) {
                    error = {
                        title: 'Error detected while trying to save the rules. See the error message below or contact an administrator.',
                        msg: data.error,
                        type: 'danger'
                    };
                }

                return Promise.resolve( error );
            };

            const pErr = await savePropertyRule();

            if ( pErr !== null ) {
                notify( {
                    type: 'error',
                    title: 'Saving Property Rules Failed'
                } );
                this.error.title = pErr.title;
                this.error.msg = pErr.msg;
                this.error.type = pErr.type;
                this.error.show = true;
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            notify( {
                type: 'success',
                title: 'Sucess',
                text: 'Property Rules Saved'
            } );

            const lErr = await saveLoginRules();

            if ( lErr !== null ) {
                notify( {
                    type: 'error',
                    title: 'Saving Login Rules Failed'
                } );
                this.error.title = lErr.title;
                this.error.msg = lErr.msg;
                this.error.type = lErr.type;
                this.error.show = true;
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            notify( {
                type: 'success',
                title: 'Sucess',
                text: 'Login Rules Saved'
            } );

            if ( !selectNext || this.search.propertyID ) {
                this.reset();
                this.clear();
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            if ( this.batchSize !== -1 && this.index === this.search.batchSize ) {
                const confirmContinue = confirm( `You've reviewed ${this.index}/${this.search.batchSize} properties. Do you want to continue reviewing?` );

                if ( !confirmContinue ) {
                    this.clear();
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }
            }

            // status did not change so the search order will not either
            if ( this.saveStatus === this.selectedProperty.status.status ) {
                this.skipped.push( this.selectedProperty.Id );
            }

            await this.selectProperty();
            this.reset();

            this.$store.dispatch( 'appLoading', false );
        },
        async startReview() {
            this.$store.dispatch( 'appLoading', true );

            await this.selectProperty();

            this.search.open = false;

            this.$store.dispatch( 'appLoading', false );
        },
        async selectProperty() {
            this.error.show = false;

            const params = this.searchParams;

            const response = await http.get( `/property-qc/next-property?${params.toString()}` );

            const rData = await response.json();

            if ( response.status !== 200 && response.status !== 204 ) {
                notify( {
                    type: 'error',
                    title: 'Error',
                    text: 'Failed to get next property'
                } );
                return;
            }

            if ( response.status === 204 ) {
                notify( {
                    type: 'success',
                    title: 'Finshed',
                    text: 'No more properties found for review'
                } );
                this.clear();
                return;
            }

            const property = rData.property;

            if ( property.Town ) {
                const townResponse = await http.get( `${process.env.LOCATIONS_API_URL}/town/${property.Town.Id}`, {
                    headers: {
                        'Authorization': `Bearer ${store.state.token}`
                    }
                } );
                const town = await townResponse.json();
                this.search.locationQuery = town.Labels.Default;
            }

            const data = Object.assign( {}, property );
            data.rules = [].concat( ( rData.propertyRules.rules || [] ), ( rData.loginRules.rules || [] ) );
            data.status = rData.status;

            this.selectedProperty = data;

            document.body.classList.add( 'split-view' );

            for ( const lang in rData.propertyPreviewURLs ) {
                this.propertyPreviewURL[ lang ] = process.env.THINKSPAIN_URL + rData.propertyPreviewURLs[ lang ] + '?preview=1';
                this.searchPreviewURL[ lang ] = process.env.THINKSPAIN_URL + rData.searchPreviewURLs[ lang ] + `?login=${data.Login}&preview=1`;
            }

            switch ( this.selectedProperty.status.status ) {
            case StatusInReview:
                this.saveStatus = StatusReviewed;
                break;
            case StatusReviewed:
                this.saveStatus = StatusReviewed;
                break;
            case StatusPending:
                this.saveStatus = StatusReviewed;
                break;
            case StatusDoNotReview:
                this.saveStatus = StatusDoNotReview;
                break;
            case StatusReReview:
                this.saveStatus = StatusReviewed;
                break;
            }

            this.setRules();
            this.index += 1;
        },
        reset() {
            for ( const handler in this.$refs ) {
                if ( !this.$refs[ handler ] ) {
                    continue;
                }
                this.$refs[ handler ].reset();
            }
        },
        setRules() {
            this.rules.attribute = this.attributeRules;
            this.rules.feature = this.featureRules;
            this.rules.location = this.locationRules;
            this.rules.media = this.mediaRules;
            this.rules.image = this.imageRules;
            this.rules.description = this.descriptionRules;
        }
    },
    mounted() {
        document.title = 'thinkSPAIN - Property QC';
        this.$store.dispatch( 'fetchPropertyTypes' );
        this.$store.dispatch( 'fetchListingTypes' );
        this.$store.dispatch( 'fetchPropertyFeatures' );

        window.onbeforeunload = ( e ) => {
            if ( this.selectedProperty === null ) {
                return;
            }

            const message =  'You have a property in review. Please finish what you are doing.';
            let event = e || window.event;

            if ( event ) {
                event.returnValue = message;
            }

            return message;
        };
    },
    created() {
        this.languages = availableLanguages;
        this.PropertyStatusOnline = PropertyStatusOnline;
        this.PropertyStatusOffline = PropertyStatusOffline;
        this.PropertyStatusAll = PropertyStatusAll;
    },
    async beforeRouteLeave( to, from, next ) {
        if ( this.selectedProperty !== null ) {
            const msg = `Are you sure you want to leave? Any changes to property ${this.selectedProperty.Id} will be lost!`;
            const continueLeave = confirm( msg );
            if ( continueLeave ) {
                await this.handleSkip( false );
                next();
            } else {
                return;
            }
        }
        this.clear();
        next();
    },
    components: {
        AttributeRuleHandler,
        DescriptionRuleHandler,
        FeatureRuleHandler,
        ImageRuleHandler,
        LocationRuleHandler,
        MediaFileRuleHandler,
        RuleSearch,
        DuplicatePropertyHandler
    }
};
</script>
<style>
    .allowScroll {
      overflow: auto;
    }

    .split-view {
      overflow: hidden;
    }

    #pane-container {
      max-height: calc(100vh - 130px);
      overflow: hidden;
    }

    .pane-inner {
      padding-bottom: 8px;
      min-height: 100%;
      position: relative;
    }

    #pane-left,
    #pane-right {
      height: auto;
      max-height: calc(100vh - 130px);
      overflow: auto;
    }

    #pane-left::-webkit-scrollbar, #pane-right::-webkit-scrollbar {
      width: 2px;
    }

    #pane-left::-webkit-scrollbar-track, #pane-right::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }

    #pane-left::-webkit-scrollbar-thumb, #pane-right::-webkit-scrollbar-thumb {
      background-color: #4382ce;
      outline: 1px solid slategrey;
    }

    .preview-dropdown {
      max-height: 400px;
      overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/property-qc/Dashboard.vue